// Filters.jsx
import React, { useMemo, useState } from "react";

export const createDefaultFilters = () => ({
  bedrooms: new Set(), // '1' | '2' | '3plus'
  attractions: new Set(), // 'pool' | 'sea' | 'parking' | 'wifi' | 'balcony' | 'kitchen' | 'ac' | 'tv' | 'elevator' | 'washer'
});

const normalizeAmenity = (val) =>
  String(val || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");

const attractionAliases = {
  pool: ["pool", "swimmingpool", "outdoorpool", "indoorpool", "communalpool"],
  sea: ["seaview", "waterfront", "waterview", "beach", "ocean"],
  parking: ["parking", "garage"],
  wifi: ["wifi", "wirelessinternet", "internet"],
  balcony: ["balcony", "patio", "terrace", "porch"],
  kitchen: ["kitchen", "stove", "cookware", "microwave", "refrigerator"],
  ac: ["airconditioning", "ac", "heatingcooling"],
  tv: ["tv", "cabletv", "smarttv"],
  elevator: ["elevator", "lift", "doorman"],
  washer: ["washer", "washingmachine", "laundry"],
};

export const applyFilters = (
  listings = [],
  filters = createDefaultFilters(),
) => {
  const { bedrooms, attractions } = filters;
  return listings.filter((item) => {
    const bedroomsCount = Number(item?.bedrooms ?? 0);
    const bedsCount = Number(
      item?.beds ?? item?.bedsCount ?? item?.bedCount ?? 0,
    );
    const inferredBedrooms =
      bedroomsCount ||
      (bedsCount ? Math.max(1, Math.round(bedsCount / 1.5)) : 0);
    const br = bedroomsCount || inferredBedrooms;
    if (bedrooms.size) {
      const passesBedroom =
        (bedrooms.has("1") && br === 1) ||
        (bedrooms.has("2") && br === 2) ||
        (bedrooms.has("3plus") && br >= 3);
      if (!passesBedroom) return false;
    }

    if (attractions.size) {
      const amenitySet = new Set([
        ...(item?.amenities || []).map(normalizeAmenity),
        ...(item?.tags || []).map(normalizeAmenity),
      ]);
      const hasAttraction = (key) => {
        const aliases = attractionAliases[key] || [];
        return [...amenitySet].some((amenity) =>
          aliases.some((alias) => amenity.includes(normalizeAmenity(alias))),
        );
      };

      for (const attr of attractions) {
        if (!hasAttraction(attr)) return false;
      }
    }

    return true;
  });
};

export const Filters = ({ value, onChange }) => {
  const state = value || createDefaultFilters();

  const update = (patch) => {
    onChange({ ...state, ...patch });
  };

  const toggleSet = (key, val) => {
    const next = new Set(state[key]);
    next.has(val) ? next.delete(val) : next.add(val);
    update({ [key]: next });
  };

  return (
    <div className="filters" dir="rtl">
      {/* <div className="filter-block">
        <div className="label">חדרים</div>
        <div className="pill-group">
          {[
            { key: "1", label: "1" },
            { key: "2", label: "2" },
            { key: "3plus", label: "3+" },
          ].map(({ key, label }) => (
            <button
              type="button"
              key={key}
              className={`pill ${state.bedrooms.has(key) ? "active" : ""}`}
              onClick={() => toggleSet("bedrooms", key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div> */}

      <div className="filter-block">
        <div className="pill-group pill-group--wrap">
          {[
            // ["pool", "בריכה"],
            ["sea", "נוף ים"],
            ["parking", "חניה"],
            // ["wifi", "WIFI"],
            ["balcony", "מרפסת"],
            // ["kitchen", "מטבח"],
            // ["ac", "מיזוג"],
            // ["tv", "טלוויזיה"],
            // ["elevator", "מעלית"],
            // ["washer", "מכונת כביסה"],
          ].map(([key, label]) => (
            <button
              type="button"
              key={key}
              className={`pill ${state.attractions.has(key) ? "active" : ""}`}
              onClick={() => toggleSet("attractions", key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="filter-actions">
        <button
          type="button"
          className="pill reset-pill"
          onClick={() => onChange(createDefaultFilters())}
        >
          איפוס סינון
        </button>
      </div>
    </div>
  );
};

// שימוש בדף "הדירות שלנו"
export const OurListings = () => {
  const [filters, setFilters] = useState(createDefaultFilters());
  const filtered = useMemo(
    () => applyFilters(window.allListings || [], filters),
    [filters],
  );

  return (
    <>
      <Filters value={filters} onChange={setFilters} />
      <ListingsGrid items={filtered} />
    </>
  );
};

// שימוש בדף תוצאות חיפוש
export const SearchResults = () => {
  const [filters, setFilters] = useState(createDefaultFilters());
  const filtered = useMemo(
    () => applyFilters(window.searchListingsData || [], filters),
    [filters],
  );

  return (
    <>
      <Filters value={filters} onChange={setFilters} />
      <ListingsGrid items={filtered} />
    </>
  );
};

// רכיב תצוגה לדוגמה (קיים או אחר)
const ListingsGrid = ({ items }) => (
  <div className="listing-grid">
    {items.map((item) => (
      <div key={item._id}>{item.title}</div>
    ))}
  </div>
);
